import React from 'react'
import anneng from "@/assets/img/home-page/anneng.png";
import baidu from "@/assets/img/home-page/baidu.png";
import baosheng from "@/assets/img/home-page/baosheng.png";
import hainan from "@/assets/img/home-page/hainan.png";
import henanluanchuan from "@/assets/img/home-page/henanluanchuan.png";
import huapei from "@/assets/img/home-page/huapei.png";
import huaxia from "@/assets/img/home-page/huaxia.png";
import jinguyinhang from "@/assets/img/home-page/jinguyinhang.png";
import luoyangnongshang from "@/assets/img/home-page/luoyangnongshang.png";
import qingdao from "@/assets/img/home-page/qingdao.png";
import wuhannongshang from "@/assets/img/home-page/wuhannongshang.png";
import wuxixishang from "@/assets/img/home-page/wuxixishang.png";
import QueueAnim from "rc-queue-anim";
import { OverPack } from "rc-scroll-anim";
import "./index.less";
const CooperativePartner = (props) => {
	const enterpriseData = [hainan, huaxia, henanluanchuan, qingdao, baosheng, luoyangnongshang, wuxixishang, jinguyinhang, wuhannongshang, baidu, anneng, huapei]
  return (
		<OverPack style={{ minHeight: 90 }} always={true} playScale={[0.2, 0.8]}>
			<QueueAnim
				key="queue"
				className="cooperative-partner-content"
				interval={120}
				leaveReverse
				type="bottom"
				component={"div"}
			>
				<div className='top-move'>
					<div className='partner-title'>合作伙伴</div>
					<div className="enterprise-list">
						{
							enterpriseData.map((item, index) => (
								<div key={`enterprise-${index}`} className="enterprise-li">
									<img src={item} alt="" className="enterprise-img" />
								</div>
							))
						}
					</div>
				</div>
			</QueueAnim>
		</OverPack>
  )
}

export default CooperativePartner;
